export default "__VITE_PUBLIC_ASSET__284b0b2c__"